module.exports = __webpack_public_path__ + "img/title4.476b6b5d.png";